// extracted by mini-css-extract-plugin
export default {"activityCard":"waJnv","activityAvatar":"F8fEm","cardContent":"AD_Oo","nameAndTime":"pc0X0","time":"S1xwS","action":"mtbwz","commentImage":"DH9rF"};